module.exports = __webpack_public_path__ + "static/img/series_book.96db185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/series_book.png
// module id = 02hO
// module chunks = 6